import { KnockGuideClient as k } from "@knocklabs/client";
import * as t from "react";
import { useKnockClient as f } from "../../core/context/KnockProvider.mjs";
import a from "../../core/hooks/useStableOptions.mjs";
import "date-fns";
const d = t.createContext(void 0), C = ({
  channelId: o,
  readyToTarget: i,
  listenForUpdates: n,
  colorMode: u = "light",
  targetParams: s,
  children: m
}) => {
  let r;
  try {
    r = f();
  } catch {
    throw new Error("KnockGuideProvider must be used within a KnockProvider");
  }
  const c = a(s), e = t.useMemo(() => new k(r, o, c), [r, o, c]);
  return t.useEffect(() => (i && (e.fetch(), n && e.subscribe()), () => e.unsubscribe()), [i, n, e]), /* @__PURE__ */ t.createElement(d.Provider, { value: {
    client: e,
    colorMode: u
  } }, m);
};
export {
  d as KnockGuideContext,
  C as KnockGuideProvider
};
//# sourceMappingURL=KnockGuideProvider.mjs.map
